import { Delete, Description, Warning } from "@mui/icons-material";
import { TableCell, useMediaQuery, useTheme } from "@mui/material";
import { useConsentContext } from "../../../contexts/ConsentContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { IframeDialog } from "../../ehrrecords/components/IframeDialog";
import {
  TableActionButton,
  TableActionGroup,
} from "../../../components/GenericTable/TableActionButton";

function ConsentActionsBar({
  row,
  type,
  fullWidth,
  compact,
  onOpenRecords,
  onViewDocument,
  onRevokeOrRenew,
}: {
  row: any;
  type: any;
  fullWidth: boolean;
  compact: boolean;
  onOpenRecords: () => void;
  onViewDocument: () => void;
  onRevokeOrRenew: () => void;
}) {
  if (type === "received") {
    if (!row?.isValid) return null;
    return (
      <TableActionGroup fullWidth={fullWidth}>
        <TableActionButton
          compact={compact}
          icon={<Description />}
          label="Prontuário"
          tone="primary"
          onClick={onOpenRecords}
        />
      </TableActionGroup>
    );
  }

  return (
    <TableActionGroup fullWidth={fullWidth}>
      {row?.binaryUrl ? (
        <TableActionButton
          compact={compact}
          icon={<Description />}
          label="Documento"
          tone="neutral"
          onClick={onViewDocument}
        />
      ) : null}
      <TableActionButton
        compact={compact}
        icon={
          row.vigency ? (
            row.isValid ? (
              <Delete />
            ) : (
              <Warning />
            )
          ) : (
            <Delete />
          )
        }
        label={row.isValid ? "Revogar" : "Renovar"}
        tone={row.isValid ? "error" : "neutral"}
        onClick={onRevokeOrRenew}
      />
    </TableActionGroup>
  );
}

export function ConsentActions({ row, type }: { row: any; type: any }) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const {
    setRevokeDialog,
    setSubjectName,
    setSubjectId,
    setRenewDialog,
    setUUID,
  } = useConsentContext();
  const navigate = useNavigate();

  const [binaryUrl, setBinaryUrl] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setBinaryUrl("");
    setOpen(false);
  };

  const actionBar = (
    <ConsentActionsBar
      row={row}
      type={type}
      fullWidth={isMobileLayout}
      compact={!isMobileLayout}
      onOpenRecords={() => {
        if (row.identifier)
          navigate("/summary", {
            state: {
              patientId: row?.identifier,
              purpose: row?.motivo,
            },
          });
      }}
      onViewDocument={() => {
        setBinaryUrl(row?.binaryUrl);
        setOpen(true);
      }}
      onRevokeOrRenew={() => {
        setSubjectId(row?.identifier);
        setSubjectName(row?.name);
        setUUID(row?.subject);
        if ((row.isValid && row.vigency) || !row.vigency) setRevokeDialog(true);
        else setRenewDialog(true);
      }}
    />
  );

  const dialogs =
    open && binaryUrl ? (
      <IframeDialog handleClose={handleClose} isOpen={open} data={binaryUrl} />
    ) : null;

  if (isMobileLayout) {
    return (
      <>
        {actionBar}
        {dialogs}
      </>
    );
  }

  return (
    <>
      <TableCell align="center" sx={{ verticalAlign: "middle" }}>
        {actionBar}
      </TableCell>
      {dialogs}
    </>
  );
}
